import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import eventHumanFriendlyDate from '../../../../misc/eventHumanFriendlyDate';
import resolvePath from '../../../../misc/resolvePath';
import ButtonLink from '../../../elements/ButtonLink';
import ListItem from '../../../elements/DEPRECATED_ListItem';
import Scrollable from '../../../elements/Scrollable';
import TopBar from '../../../elements/TopBar/TopBar';
import Validate from '../../../validate/Validate';
import PleaseWait from '../../PleaseWait';
import Screen from '../../Screen';

class ConfirmDeleteEventScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mounted: false,
            busy: false,
        };
    }
    componentDidMount() {
        this.state.mounted = true;
    }
    componentWillUnmount() {
        this.state.mounted = false;
    }
    render() {
        if (this.state.busy) {
            return <PleaseWait />;
        }

        let {i18n, event} = this.props,
            header = (
                <div>
                    <TopBar returnURL=".." />
                    <hr />
                    <div className="content bgwhite text">{i18n['label.delete.personal.data']}</div>
                    <ListItem icon={event.icon_url}>
                        <p className="text main">{event.name}</p>
                        {event._isEvent ? <p className="text">{eventHumanFriendlyDate(event, event.start_utc, event.end_utc)}</p> : null}
                    </ListItem>
                    <hr />
                </div>
            ),
            footer = (
                <div className="content">
                    <table className="layout">
                        <tbody>
                            <tr>
                                <td
                                    style={{
                                        paddingRight: '1em',
                                    }}>
                                    <ButtonLink
                                        href=".."
                                        style={{
                                            border: 0,
                                            fontSize: '150%',
                                            backgroundColor: 'white',
                                        }}>
                                        {i18n['label.cancel']}
                                    </ButtonLink>
                                </td>
                                <td>
                                    <ButtonLink
                                        onClick={this.handleDeleteEvent.bind(this)}
                                        style={{
                                            border: 0,
                                            backgroundColor: 'red',
                                            color: 'white',
                                            fontSize: '150%',
                                        }}>
                                        {i18n['button.yes-permanently']}
                                    </ButtonLink>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );

        return (
            <Screen header={header} footer={footer}>
                <Scrollable>
                    <div className="content text">
                        <div
                            style={{
                                fontSize: '130%',
                            }}>
                            <br />
                            <h4>{i18n['label.deleteprofile.heading']}</h4>
                            <br />{' '}
                            {event._isEvent ? (
                                <div>
                                    <p>{i18n['label.eventdelete.paragraph1']}</p>
                                    <p>{i18n['label.eventdelete.paragraph2']}</p>
                                    <p>{i18n['label.eventdelete.paragraph3']}</p>
                                    <p>{i18n['label.eventdelete.paragraph4']}</p>
                                    <p>{i18n['label.eventdelete.paragraph5']}</p>
                                    <p>{i18n['label.eventdelete.paragraph6']}</p>
                                </div>
                            ) : null}
                            {event._isCommunity ? (
                                <div>
                                    <p>{i18n['label.comunitydelete.paragraph1']}</p>
                                    <p>{i18n['label.comunitydelete.paragraph2']}</p>
                                    <p>{i18n['label.comunitydelete.paragraph3']}</p>
                                    <p>{i18n['label.comunitydelete.paragraph4']}</p>
                                    <p>{i18n['label.comunitydelete.paragraph5']}</p>
                                    <p>{i18n['label.comunitydelete.paragraph6']}</p>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </Scrollable>
            </Screen>
        );
    }
    handleDeleteEvent() {
        this.setState({busy: true});
        app.api.events
            .deleteFromEvent(this.props.eventId)
            .then(() => {
                app.history.push(resolvePath(location.pathname, '..'));
            })
            .catch(console.error)
            .then(() => {
                if (this.state.mounted) {
                    this.setState({busy: false});
                }
            });
    }
}

const ConnectedScreenComponent = connect((state, props) => {
    return {
        i18n: state.i18n.translations,
        event: _(state).get(`events[${props.eventId}].event`, {}), // give it a default value for when it's removed and still in this page until redirection ends
    };
})(ConfirmDeleteEventScreen);

export default props => (
    <Validate
        validate={state => {
            if (!_(state).get(`events[${props.match.params.eventId}].event`)) {
                throw new Error('Event ' + props.match.params.eventId + ' not found');
            }
        }}>
        <ConnectedScreenComponent {...props.match.params} />
    </Validate>
);
